module.exports = "/assets/06458e3a4b4eac8c8acd169cbc67382a.svg";